import {CardPattern} from './card-pattern';

/**
 * Allows the differentiation between various carddeck types
 *
 * Is necessary in order to use the same data structure and templates
 * for different carddeck types. Depending on the carddeck type other
 * rest api endpoints have to be addressed.
 */
export enum DeckType{
  pattern = 'pattern',
  problem = 'problem',
  causes = 'causes',
  linkage = 'linkages'
}

/**
 * Data structure for a CardDeck
 *
 * Consists of CardPatterns.
 */
export interface CardDeck {
  id: number;
  name: string;
  type: DeckType;
  cardPatterns?: CardPattern[];
}

export enum LinkageDirection{
  left = 'left',
  middle = 'middle',
  right = 'right'
}

// LinkageType is derived from the array of sourceIs and targetIds
export enum LinkageType {
  oneToOne = 'oneToOne',
  oneToMany = 'oneToMany',
  manyToOne = 'manyToOne',
  manyToMany = 'manyToMany'
}

// PathType is derived fom incoming and outgoing paths of linkage cards
export enum PathType {
  oneToOne = 'oneToOne',
  oneToMany = 'oneToMany',
  manyToOne = 'manyToOne',
  manyToMany = 'manyToMany'
}

